module.exports = __webpack_public_path__ + "img/iphone-map-SWEDEN-sv.58e632f3.png";